import {customElement, property, query} from 'lit/decorators.js';
import {html} from 'lit';
import {FlywheelComponent} from '#lit/lib/component.js';
import styles from './style.scss';
import type FlyModal from '#lit/components/base/modal/index.js';

export const FACEBOOK_AUTH_MODAL_ELEMENT_TAG = 'facebook-auth-modal';
const REAUTH_QUERY_STRING = 'facebook_reauth';

enum FacebookModalContexts {
  SIGN_IN = 'sign-in',
  REAUTH = 'reauth',
}

const contextQueryMap: Map<FacebookModalContexts, string> = new Map([
  [FacebookModalContexts.REAUTH, REAUTH_QUERY_STRING],
]);

/**
 * FacebookAuthModal -- Description here
 */
@customElement(FACEBOOK_AUTH_MODAL_ELEMENT_TAG)
export default class FacebookAuthModal extends FlywheelComponent {
  @property()
  context: FacebookModalContexts = FacebookModalContexts.SIGN_IN;

  @query('fly-modal')
  modal: FlyModal | undefined;

  static get styles() {
    return [styles];
  }

  openModal() {
    if (this.modal) this.modal.openModal();
  }

  rendered() {
    const query = this.queries.get('state');
    const contextParam = contextQueryMap.get(this.context);

    if (query && this.modal && contextParam && query === contextParam) {
      this.openModal();
    }
  }

  render() {
    return html`
      <fly-modal>
        <div id="auth0-fb-${this.context}" style="margin: 40px auto;"></div>
        <slot></slot>
      </fly-modal>
    `;
  }
}
